module.exports = __webpack_public_path__ + "assets/smile-faces.66280a57296df78cef061dfb340494b4.png";